import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import Switch from '@/components/FormElements/Switch';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileSettingsAugmented } from '@/store/user/selectors/selectActiveProfileSettingsAugmented';
import { updateProfileSetting } from '@/store/user/thunks/updateProfileSetting';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function DybrFeedSettings() {
  const dispatch = useDispatch();
  const [token] = useTokenState();
  const { activeProfileId } = useActiveProfile();

  const settings = useSelector(state =>
    selectActiveProfileSettingsAugmented(state, { activeProfileId })
  );

  const [dybrFeed, setDybrFeed] = useState(
    settings?.privacy?.dybrfeed ?? false
  );

  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Общая лента Дыбра</h4>
          <p>
            На Дыбре есть общая лента всех записей. Вы можете исключить из неё
            свой дневник.
          </p>
        </SettingSectionTitle>
        <Settings>
          <Switch
            label="участвовать в общей ленте"
            checked={dybrFeed}
            onClick={e => {
              dispatch(
                updateProfileSetting(
                  'privacy.dybrfeed',
                  e.target.checked,
                  token
                )
              );
              setDybrFeed(e.target.checked);
            }}
          />
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}

export default DybrFeedSettings;
